export default "__VITE_ASSET__BNenA9Q1__$_?url__"